import { render } from "./FormRow.vue?vue&type=template&id=133aca58&scoped=true&ts=true"
import script from "./FormRow.vue?vue&type=script&lang=ts"
export * from "./FormRow.vue?vue&type=script&lang=ts"

import "./FormRow.vue?vue&type=style&index=0&id=133aca58&scoped=true&lang=css"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133aca58"]])

export default __exports__